import { FunctionComponent, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { useAmplitude } from '@kanda-libs/ks-amplitude-provider';
import {
  // FirebaseAuthService,
  revalidateUser,
  useCurrentUser, // useMutate,
} from '@kanda-libs/ks-frontend-services';

import { useAppDispatch } from 'components/App';
import { APP_ENV, HIGHLIGHT_KEY, REFRESH_TOKEN_TIMER } from 'config';
import { H } from 'highlight.run';
import { selectors } from 'store';

interface ContainerComponentProps {
  children?: JSX.Element | JSX.Element[];
}

const ContainerComponent: FunctionComponent<ContainerComponentProps> = ({
  children,
}) => {
  const { isUserLoggedIn } = useCurrentUser();
  const dispatch = useAppDispatch();
  const { setUserId } = useAmplitude();

  const user = useSelector(selectors.getUser);

  // const { mutate: refreshToken } = useMutate(
  //   FirebaseAuthService.token.bind(FirebaseAuthService),
  // );

  useEffect(() => {
    if (APP_ENV === 'qa') return;
    H.init(HIGHLIGHT_KEY, {
      environment: APP_ENV,
      networkRecording: {
        recordHeadersAndBody: true,
      },
    });
  }, []);

  const timerRef = useRef<NodeJS.Timer | null>(null);
  useEffect(() => {
    if (!isUserLoggedIn) return () => {};
    timerRef.current = setInterval(() => {
      dispatch(revalidateUser());
    }, REFRESH_TOKEN_TIMER);
    return () => {
      clearTimeout(timerRef.current as unknown as number);
    };
  }, [isUserLoggedIn, dispatch]);

  useEffect(() => {
    if (!user) return;
    setUserId(user.id);
  }, [user, setUserId]);

  return <>{children}</>;
};

ContainerComponent.displayName = 'AppWrapper-container';

export default ContainerComponent;
